'use client';

import React from 'react';
import { Card } from '../ui/card';
import { cn } from '@/lib/utils';

const SkeletonCard = () => {
	return (
		<Card className='w-full animate-pulse drop-shadow-lg rounded-md overflow-hidden bg-muted'>
			<div className='w-full aspect-[16/9] bg-gray-300 rounded-md' />
			<div className='p-4'>
				<div className='h-6 bg-gray-300 rounded-md w-3/4 mb-3' />
				<div className='h-4 bg-gray-300 rounded-md w-1/2 mb-2' />
				<div className='h-4 bg-gray-300 rounded-md w-1/3 mb-4' />
				<div className='h-10 bg-gray-300 rounded-md w-full' />
			</div>
		</Card>
	);
};

export default SkeletonCard;
